// extracted by mini-css-extract-plugin
export default {"revShareAmount":"C0rvuP"};